<template>
  <div v-if="showLoading" class="loading-cpaps">
    <img src="../../public/img/loading_cpaps.gif" alt="Carregando..." />
  </div>
</template>

<script>
export default {
  name: "LoadingCpaps",
  props: {
    showLoading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.loading-cpaps {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);

  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: all;
  cursor: wait;

  img {
    width: 18%;
    max-width: 350px;
  }
}

@media (max-width: 767px) {
  .loading-cpaps img {
    width: 85%;
    max-width: none;
  }
}
</style>
